import './Discount.css'

export const Discount = () => {
    return (
        <div className={'textContainer'}>
            <span className={'discount'}>Скидка 20% в будние дни !</span>
        </div>
    )
}
